import * as React from "react"
import { Grid } from "@mui/material"

import { ANALYTICS_ROUTES, HOME_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { CatalogueDetailsIsEmpty } from "./@signals"
import AnalyticsGeneralFilters from "./Filters"
import AnalyticsDetailsTable from "./Table"


export default function AnalyticsDetailsPage() {
    const props = {
        head: `DIP Insight | ${ANALYTICS_ROUTES.TITLE}`,
        title: ANALYTICS_ROUTES.DETAILS_TITLE,
        subtitle: ANALYTICS_ROUTES.SUBTITLE,
        isEmpty: CatalogueDetailsIsEmpty.value,
        actions:null,
        filters: <AnalyticsGeneralFilters />,
    }

    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <AnalyticsDetailsTable />
            </Grid>
        </Grid>
    </PageWrapper>
}